import { Injectable, inject } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { tap, withLatestFrom } from "rxjs";

// Store
import { Store } from "@ngrx/store";
import * as SportsbookActions from "../../../stores/sportsbook/sportsbook.actions";
import { SportsbookState } from "../../../stores/sportsbook/sportsbook.reducers";

// Utils
import { SPORTS_NAVIGATION_CONFIG } from "@sports-services/sports.navigation.service";
import { SportTrackPollingService } from "@sports-services/track.polling.service";

@Injectable({ providedIn: "root" })
export class SportsbookErrorEffects {
  // Services
  actions$ = inject(Actions);
  sportTrackPollingService = inject(SportTrackPollingService);

  // Utils
  store = inject(Store<SportsbookState>);

  stopAllPollingAfterErrorWithNavigationActionOnConfirm$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(SportsbookActions.setSportsError),
        withLatestFrom(this.store.select("sportsbook")),
        tap(([{ type, ...payload }, data]) => {
          if (payload.errorCode) {
            const currentPage = data.navigationData.currentUrl.url?.split("?")[0].slice(1);
            const messageWithNavigationActionOnConfirm =
              SPORTS_NAVIGATION_CONFIG[currentPage]?.ERROR_CODE_BEHAVIOR?.[payload.errorCode]?.reload ||
              SPORTS_NAVIGATION_CONFIG[currentPage]?.ERROR_CODE_BEHAVIOR?.[payload.errorCode]?.back ||
              SPORTS_NAVIGATION_CONFIG[currentPage]?.ERROR_CODE_BEHAVIOR?.[payload.errorCode]?.redirectTo;
            if (messageWithNavigationActionOnConfirm) {
              this.sportTrackPollingService.stopAllPollings();
            }
          }
        }),
      ),
    { functional: true, dispatch: false },
  );
}
